import React from "react"
import { CustomImage } from "./CustomImage"
import { Link } from "gatsby"

interface PersonCalendarCardProps {
  thumbnail?: string
  image_alt?: string
  name: string
  position: string
  mail?: string
  phone: string
  linkedin: string
  xing: string
  calendly?: string
}

export const PersonCalendarCard = ({
  thumbnail,
  image_alt,
  name,
  position,
  phone,
  mail,
  xing,
  linkedin,
  calendly,
}: PersonCalendarCardProps) => {
  return (
    <div className="w-fit flex flex-row gap-4 bg-lightgray items-center py-8 px-8">
      <div className={"w-56 p-4 pl-0 mx-2 hidden lg:block"}>
        <CustomImage
          src={thumbnail || ""}
          alt={image_alt || ""}
          className={"rounded-full"}
        />
      </div>
      <div>
        <div className={"flex flex-col gap-2"}>
          <h2 className={"text-[24px] font-semibold font-serif"}>{name}</h2>
          <p className={"text-green"}>{position}</p>
          <div className={"flex flex-row gap-2"}>
            {phone && (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  className="bi bi-telephone-fill w-4 col-span-1 my-auto text-black"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                  />
                </svg>
                <a href={`tel:${phone}`} className={"col-span-8 my-auto"}>
                  {phone}
                </a>
              </>
            )}
          </div>
          <div className={"flex flex-row gap-2"}>
            {linkedin && (
              <>
                <img
                  src={"/assets/linkedin.svg"}
                  alt={"linkedin logo"}
                  className={"h-4 my-auto"}
                />
                <a
                  href={linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={"col-span-8"}
                >
                  LinkedIn Profil
                </a>
              </>
            )}
          </div>
          <div className={"flex flex-row gap-2"}>
            {xing && (
              <>
                <img
                  src={"/assets/xing.svg"}
                  alt={"xing logo"}
                  className={"h-4 my-auto"}
                />
                <a
                  href={xing}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={"col-span-8"}
                >
                  Xing Profil
                </a>
              </>
            )}
          </div>
          <div className={"mt-4"}>
            {calendly && (
              <Link
                to={calendly}
                className={
                  "hover:font-semibold border p-5 uppercase tracking-wider flex"
                }
              >
                Termin jetzt online buchen
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
